
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Text } from "@chakra-ui/react";


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Text textStyle="paragraph-sm" mdxType="Text">
  Di seguito sono elencate tutte le categorie di eredi legittimi. Selezionate le
  persone alle quali desiderate lasciare un'eredità in caso di morte.
    </Text>
    <Text textStyle="paragraph-sm" mdxType="Text">Lascio i seguenti eredi legittimi:</Text>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;